import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavItemComponent } from '@components/master-layout/navs/components/nav-item/nav-item.component';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  matEventAvailable,
  matFlag,
  matHub,
  matLightbulb,
  matPeopleAlt,
} from '@ng-icons/material-icons/baseline';
import { TranslateModule } from '@ngx-translate/core';
import { InternalIconComponent } from '@shared/components/internal-icon/internal-icon.component';
import { SharedIconComponent } from '@shared/components/shared-icon/shared-icon.component';
import { ActiveRouteDirective } from '@shared/directives/active-route.directive';
import { LanguagePathDirective } from '@shared/directives/language-path.directive';
import { UnsavedFormCheckDirective } from '@shared/directives/unsaved-form-check.directive';

@Component({
  selector: 'app-nav-item-dropdown',
  templateUrl: './nav-item-dropdown.component.html',
  imports: [
    CommonModule,
    NgIcon,
    ActiveRouteDirective,
    LanguagePathDirective,
    UnsavedFormCheckDirective,
    SharedIconComponent,
    InternalIconComponent,
    TranslateModule,
  ],
  viewProviders: [
    provideIcons({
      matFlag,
      matLightbulb,
      matPeopleAlt,
      matEventAvailable,
      matHub,
    }),
  ],
})
export class NavItemDropdownComponent extends NavItemComponent {}
